import { render, staticRenderFns } from "./print_info_manage_preview.vue?vue&type=template&id=83c229e2&class=text_google&"
import script from "./print_info_manage_preview.vue?vue&type=script&lang=js&"
export * from "./print_info_manage_preview.vue?vue&type=script&lang=js&"
import style0 from "./print_info_manage_preview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VApp,VIcon,VImg})
